module.exports = __webpack_public_path__ + "static/f142ec526b6ed8c7c2f70fcf7f9a358bcf9d9401a197022cdf5c7fc9f34236f6-3be9224366d9ba4b1c58ca355d8d5e85.png";